export const Adventure = require('./adventure.jpg');
export const Art = require('./art.jpg');
export const Food = require('./food.jpg');
export const Music = require('./music.jpg');
export const Nature = require('./nature.jpg');
export const Space = require('./space.jpg');
export const Style = require('./style.jpg');
export const Travel = require('./travel.jpg');
export const Wellness = require('./wellness.jpg');
